/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
import React from 'react'
import PropTypes from 'prop-types'
import {List, ListItem, useMultiStyleConfig} from '@chakra-ui/react'
import Link from '../../components/link'

const LinksList = ({links, variant, onLinkClick, children}) => {
    const styles = useMultiStyleConfig('LinksList', {variant})
    const childrenArray = React.Children.toArray(children)
    if (!links?.length && !childrenArray.length) {
        return null
    }

    return (
        <List {...styles.list} spacing={0} data-testid={`links-list-${variant}`}>
            {links?.map((link, i) => (
                <ListItem {...styles.listItem} key={i}>
                    <Link
                        {...styles.link}
                        {...link.styles}
                        to={link.href}
                        onClick={onLinkClick}
                        isExternal={link.isExternal}
                    >
                        {link.text}
                    </Link>
                </ListItem>
            ))}
            {childrenArray.map((child, i) => (
                <ListItem {...styles.listItem} key={i}>
                    {child}
                </ListItem>
            ))}
        </List>
    )
}

LinksList.propTypes = {
    children: PropTypes.node,
    links: PropTypes.arrayOf(
        PropTypes.shape({
            href: PropTypes.string,
            text: PropTypes.string
        })
    ),
    variant: PropTypes.oneOf(['footerLinks', 'footer', 'checkoutFooter']),
    onLinkClick: PropTypes.func
}

export default LinksList
